import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section--column--center" }
const _hoisted_2 = { class: "TwoFactorWizardstep-size-security" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('TwoFactorAuth.InfQuestion1')), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('TwoFactorAuth.InfDesc1')), 1),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('TwoFactorAuth.InfQuestion2')), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('TwoFactorAuth.InfDesc2')), 1),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('TwoFactorAuth.InfQuestion2')), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('TwoFactorAuth.InfDesc3')), 1)
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toContinue && _ctx.toContinue(...args))),
      class: "btn btn-primary p-x-2 border__rounded btn-2fa"
    }, _toDisplayString(_ctx.$t('wizard.next')), 1)
  ]))
}